import { User, signOut } from 'firebase/auth';
import { Dispatch } from 'redux';
import { auth } from '../../../firebaseConfig';
import { authConstants } from './constants';
import { userActions } from '../../user/store/actions';
import { backendApi } from '../../../common/apiService';

export const authActions = {
    authenticationSuccess,
    failed,
    logoutSuccess,
    logout
};

export const actionCreator = {
    success: (userData: User | null) => {
        if (!userData) {
            return { type: authConstants.LOGIN_SUCCESS, userData: null };
        }

        return { type: authConstants.LOGIN_SUCCESS, userData: userData.toJSON() };
    },
    request: () => { return { type: authConstants.LOGIN_REQUEST } },
    failed: () => { return { type: authConstants.LOGIN_FAILED } },
    logout: () => { return { type: authConstants.LOGOUT } }
};

function authenticationSuccess(userData: User | null) {
    return (dispatch: Dispatch) => {
        dispatch(actionCreator.success(userData));
    };
}

function failed(message: string) {
    return (dispatch: Dispatch) => {
        //console.log('Auth failed message:', message);
        dispatch(actionCreator.failed());
    };
}

function logout() {
    return (dispatch: Dispatch) => {
        signOut(auth)
            .then(() => {
                dispatch(actionCreator.logout());
            })
            .catch(err => {
                //console.log("[authentication actions - logout]  error logging out:", err);
            })
    };
}

function logoutSuccess() {
    return actionCreator.logout();
}

export function createUser(token: string, user_id: string,first_name?:string|null,created_at?:string|undefined,email?:string|null) {
	return new Promise<boolean>(async (resolve, reject) => {
		let config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};
		console.log(first_name,email,created_at)
		// Transform created_at to Unix timestamp (number) if it exists
		let parsedCreatedAt: number | undefined = undefined;
		if (created_at) {
			try {
				// If created_at is already a Unix timestamp string, convert to number
				if (/^\d+$/.test(created_at)) {
					parsedCreatedAt = parseInt(created_at, 10);
				} 
				// If created_at is an ISO date string, convert to Unix timestamp
				else {
					parsedCreatedAt = Math.floor(new Date(created_at).getTime() / 1000);
				}
			} catch (error) {
				console.warn('Failed to parse created_at:', created_at, error);
				// Leave as undefined if parsing fails
			}
		}
		let body = {
			id: user_id,
			email:email,
			first_name:first_name,
			created_at:parsedCreatedAt,
		};
		backendApi
			.post(`/users`, body,config)
			.then((response) => {
				console.log(response)
				if (response.status === 201) {
					console.log(response.data)
					resolve(true);
				} else if(response.status === 200) {
					console.log("user already exists, no need to create")
					resolve(true);
				} else {
					reject(new Error(`[createUser]Request failed with status ${response.status}`));
				}
			})
			.catch((error) => {
				console.error(`[createUser]Error fetching files `, error);
				reject(error);
			});
	});
}

export function deleteUser(token: string, user_id: string) {
	return new Promise<boolean>(async (resolve, reject) => {
		let config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};

		backendApi
			.delete(`/users/${user_id}`,config)
			.then((response) => {
				if (response.status === 200) {
					console.log(response.data)
					resolve(true);
				} else {
					reject(new Error(`[getUserFiles]Request failed with status ${response.status}`));
				}
			})
			.catch((error) => {
				console.error(`[getUserFiles]Error fetching files `, error);
				reject(error);
			});
	});
}